<template>
    <div class="gamelist" id="gamelist">
        <div class="box_padding">
            <div class="game_list">
                <h1 class="game_logo">会员传奇，多倍一站式畅玩</h1>
                <div class="search_box">
                    <img class="fdj" src="/gamelist/img/fdj.png">
                    <input type="text" class="search" data-toggle="popover" :data-keys="{ keyWord, g_name }" placeholder="请输入关键词快捷找服"
                        v-model="keyWord" @keydown.enter="search()">
                </div>
                <div class="list_top">
                    <div class="list_item">
                        <ul>
                            <li @click="curId = 0" :class="{ 'active': curId === 0 }"><span>全部</span></li>
                            <li v-for="gc in gamesClass" :key="gc.value" @click="curId = gc.value; click_game_class(gc.label)"
                                :class="{ 'active': curId === gc.value }">
                                <span>{{ gc.label }}</span>
                            </li>
                            <router-link to="/removegame"><li><span class="text_ellipsis">待下架专区</span></li></router-link>
                        </ul>
                        
                    </div>
                </div>
                <div class="content mt-5">
                    <div class="box s_box" v-show="curId === 0">
                        <div class="box" v-for="sz in specialZone" :key="sz.value">
                            <div class="qutop" v-if="filteredGamesZone(sz.value,1).length">
                                <div class="section_1">
                                    <div class="text-wrapper_1">
                                        <span class="text_1">{{ sz.label }}</span>
                                    </div>
                                    <span class="text_2">{{ sz.content }}</span>
                                    <img
                                    class="image_1"
                                    referrerpolicy="no-referrer"
                                    src="/gamelist/img/3.png"
                                    />
                                </div>
                            </div>
                            <div class="model " v-for="game in filteredGamesZone(sz.value,1)" :key="game.id">
                                <div class="model_img_box">
                                    <div class="countdown-timer" v-if="game.kaifu_time">
                                        <span class="countdown-text">距离开服还有:</span>
                                        <span class="countdown-time">{{ formatCountdown(game.kaifu_time) }}</span>
                                    </div>
                                    <img class="model_under" v-if="game.is_under == 1" :src="img_url + material.pc_under_icon">
                                    <!-- <img class="model_under 11" v-if="game.column_img_type !=1" :src="img_url + game.column_icon"> -->
                                    <img class="model_under" v-if="game.column_img_type == 3" :src="img_url + game.column_img">
                                    <img class="model_img" v-lazy="img_url + game.game_image" width="100%" height="100%">
                                    <div class="game_hover_box">
                                        <img class="game_hover_img" :src="img_url + game.game_icon" width="50px" >
                                        <div class="game_btn_box flex_box">
                                            <a class="btn_font down btn_hover flex_box" @click="downloadFile(game.client_url)"
                                                :class="{ 'lang_btn': delang === true }"><span
                                                    :class="{ 'lang_point': lang === true }" title="下载游戏">下载游戏</span></a>
                                            <a @click="toGameDetails(game.id, game.game_id,userInfo.id,game.classify_name)" class="btn_font look btn_hover  flex_box"
                                                :class="{ 'lang_btn': delang === true }"><span
                                                    :class="{ 'lang_point': lang === true }" title="查看详情">查看详情</span></a>
                                            <a :href="game.web_url" class=" web_btn btn_hover btn_font text_ellipsis" target="_blank">官方网站</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="model_title">
                                    <div class="text_box">
                                        <div class="game_name" @click="toGameDetails(game.id, game.game_id,userInfo.id,game.classify_name)">
                                            <h5 :title="game.game_name" class="g_name lang_point">{{ game.game_name }}</h5>
                                        </div>
                                        <span class="fu_title lang_point" :title="game.game_introduce">{{ game.game_introduce }}</span>
                                    </div>
                                    <div class="btn_box" v-if="game.button_display">
                                        <a class="btn_font linqv  flex_box"
                                            @click="flID = game.game_id; id = game.id; game_name = game.game_name; img = game.game_image;under_time = game.under_time;is_under = game.is_under; receiveBenefits(game.game_id)"
                                            :class="{ 'lang_btn': delang === true }"><span
                                                :class=" { 'lang_point': lang === true } " title="兑换充值">兑换充值</span></a>
                                    </div>
                                    <div class="btn_box" v-else></div>
                                </div>
                            </div>
                        </div>
                        <div class="qutopA" v-if="specialZone.length > 0 && normalFuFlag">
                            <span class="text_3">严选新服专区</span>
                        </div>
                        <div class="model " v-for="game in  filteredGamesZone(0,2)" :key="game.id">
                            <div class="model_img_box" >
                                <div class="countdown-timer" v-if="game.kaifu_time">
                                    <span class="countdown-text">距离开服还有:</span>
                                    <span class="countdown-time">{{ formatCountdown(game.kaifu_time) }}</span>
                                </div>
                                <img class="model_under" v-if="game.is_under == 1" :src="img_url + material.pc_under_icon">
                                <!-- <img class="model_under 11" v-if="game.column_img_type !=1" :src="img_url + game.column_icon"> -->
                                <img class="model_under" v-if="game.column_img_type == 3" :src="img_url + game.column_img">
                                <img class="model_img" v-lazy="img_url + game.game_image" width="100%" height="100%">
                                <div class="game_hover_box">
                                    <img class="game_hover_img" :src="img_url + game.game_icon" width="50px" >
                                    <div class="game_btn_box flex_box">
                                        <a class="btn_font down btn_hover flex_box" @click="downloadFile(game.client_url)"
                                            :class="{ 'lang_btn': delang === true }"><span
                                                :class="{ 'lang_point': lang === true }" title="下载游戏">下载游戏</span></a>
                                        <a @click="toGameDetails(game.id, game.game_id,userInfo.id,game.classify_name)" class="btn_font look btn_hover  flex_box"
                                            :class="{ 'lang_btn': delang === true }"><span
                                                :class="{ 'lang_point': lang === true }" title="查看详情">查看详情</span></a>
                                        <a :href="game.web_url" class=" web_btn btn_hover btn_font text_ellipsis" target="_blank">官方网站</a>
                                    </div>
                                </div>
                            </div>
                            <div class="model_title">
                                <div class="text_box">
                                    <div class="game_name" @click="toGameDetails(game.id, game.game_id,userInfo.id,game.classify_name)">
                                        <h5 :title="game.game_name" class="g_name lang_point">{{ game.game_name }}</h5>
                                    </div>
                                    <span class="fu_title lang_point" :title="game.game_introduce">{{ game.game_introduce }}</span>
                                </div>
                                <div class="btn_box" v-if="game.button_display">
                                    <a class="btn_font linqv  flex_box"
                                        @click="flID = game.game_id; id = game.id; game_name = game.game_name; img = game.game_image;under_time = game.under_time;is_under = game.is_under; receiveBenefits(game.game_id)"
                                        :class="{ 'lang_btn': delang === true }"><span
                                            :class=" { 'lang_point': lang === true } " title="兑换充值">兑换充值</span></a>
                                </div>
                                    <div class="btn_box" v-else></div>
                            </div>
                        </div>
                    </div>
                    <div class="box s_box" v-show=" curId === -1 ">
                        <div class="model " v-for=" s  in  searchGame " :key=" s.id ">
                            <div class="model_img_box" >
                                <div class="countdown-timer" v-if="s.kaifu_time">
                                    <span class="countdown-text">距离开服还有:</span>
                                    <span class="countdown-time">{{ formatCountdown(s.kaifu_time) }}</span>
                                </div>
                                <img class="model_under" v-if="s.is_under == 1" :src="img_url + material.pc_under_icon">
                                <!-- <img class="model_under" v-else-if="s.column_img_type !=1" :src="img_url + s.column_icon"> -->
                                <img class="model_under" v-if="s.column_img_type == 3" :src="img_url + s.column_img">
                                <img class="model_img" v-lazy=" img_url + s.game_image " width="100%" height="100%">
                                <div class="game_hover_box">
                                    <img class="game_hover_img" :src="img_url + s.game_icon" width="50px" >
                                    <div class="game_btn_box flex_box">
                                        <a class="btn_font down btn_hover flex_box" @click="downloadFile(s.client_url)"
                                            :class="{ 'lang_btn': delang === true }"><span
                                                :class="{ 'lang_point': lang === true }" title="下载游戏">下载游戏</span></a>
                                        <a @click="toGameDetails(s.id, s.game_id,userInfo.id,s.classify_name)" class="btn_font look btn_hover  flex_box"
                                            :class="{ 'lang_btn': delang === true }"><span
                                                :class="{ 'lang_point': lang === true }" title="查看详情">查看详情</span></a>
                                        <a :href="s.web_url" class="web_btn btn_hover btn_font text_ellipsis" target="_blank">官方网站</a>
                                    </div>
                                </div>
                            </div>
                            <div class="model_title">
                                <div class="container">
                                    <div class="text_box">
                                        <div class="game_name" @click=" toGameDetails(s.id, s.game_id,userInfo.id,s.classify_name) ">
                                            <h5 :title="s.game_name" class="g_name lang_point">{{s.game_name}}</h5>
                                        </div>
                                        <span class="fu_title lang_point" :title="s.game_introduce">{{ s.game_introduce }}</span>
                                    </div>
                                    <div class="btn_box" v-if="s.button_display">
                                        <a class="btn_font linqv  flex_box"
                                            @click=" flID = s.game_id; id = s.id; game_name = s.game_name; img = s.game_image;under_time = s.under_time;is_under = s.is_under; receiveBenefits(s.game_id) "
                                            :class=" { 'lang_btn': delang === true } "><span
                                                :class=" { 'lang_point': lang === true } " title="兑换充值">兑换充值</span></a>
                                    </div>
                                    <div class="btn_box" v-else></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box s_box" v-for=" gc  in  gamesClass " :key=" gc.value " v-show=" curId === gc.value ">
                        <div class="model_w" v-for=" gb  in  games " :key=" gb.id ">
                            <div class=" model1" v-show=" curId === gb.classify ">
                                <div class="model_img_box" >
                                    <div class="countdown-timer" v-if="gb.kaifu_time">
                                        <span class="countdown-text">距离开服还有:</span>
                                        <span class="countdown-time">{{ formatCountdown(gb.kaifu_time) }}</span>
                                    </div>
                                    <img class="model_under" v-if="gb.is_under == 1" :src="img_url + material.pc_under_icon">
                                    <!-- <img class="model_under" v-else-if="gb.column_img_type !=1" :src="img_url + gb.column_icon"> -->
                                    <img class="model_under" v-else-if="gb.column_img_type == 3" :src="img_url + gb.column_img">
                                    <img class="model_img" v-lazy=" img_url + gb.game_image " width="100%" height="100%">
                                    <div class="game_hover_box">
                                        <img class="game_hover_img" :src="img_url + gb.game_icon" width="50px" >
                                        <div class="game_btn_box flex_box">
                                            <a class="btn_font down btn_hover flex_box" @click="downloadFile(gb.client_url)"
                                                :class="{ 'lang_btn': delang === true }"><span
                                                    :class="{ 'lang_point': lang === true }" title="下载游戏">下载游戏</span></a>
                                            <a @click="toGameDetails(gb.id, gb.game_id,userInfo.id,gb.classify_name)" class="btn_font look btn_hover  flex_box"
                                                :class="{ 'lang_btn': delang === true }"><span
                                                    :class="{ 'lang_point': lang === true }" title="查看详情">查看详情</span></a>
                                            <a :href="gb.web_url" class="web_btn btn_hover  btn_font text_ellipsis" target="_blank">官方网站</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="model_title">
                                    <div class="container">
                                        <div class="text_box">
                                            <div class="game_name" @click=" toGameDetails(gb.id, gb.game_id,userInfo.id,gb.classify_name) ">
                                                <h5 :title="gb.game_name" class="g_name lang_point">{{gb.game_name}}</h5>
                                            </div>
                                            <span class="fu_title lang_point" :title="gb.game_introduce">{{ gb.game_introduce }}</span>
                                        </div>
                                        <div class="btn_box" v-if="gb.button_display">
                                            <a class="btn_font linqv  flex_box"
                                                @click=" flID = gb.game_id; id = gb.id; game_name = gb.game_name; img = gb.game_image;under_time = gb.under_time;is_under = gb.is_under;receiveBenefits(gb.game_id) "
                                                :class=" { 'lang_btn': delang === true } "><span
                                                    :class=" { 'lang_point': lang === true } " title="兑换充值">兑换充值</span></a>
                                        </div>
                                    <div class="btn_box" v-else></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ReceiveBenefits ref="rec" :id="id" :game_id="flID"  :game_name=" game_name " :img=" img "  :under_time="under_time" :is_under="is_under"></ReceiveBenefits>
    </div>
</template>
  
<script>
import { auto } from "@popperjs/core";
import layer from "layui-layer";
import { getGameList, getGameClass, searchGameList, getGameZone } from '@/api/http.js'
import { mapState } from "vuex";
import ReceiveBenefits from '@/components/ReceiveBenefits.vue'
import {Bus} from '@/router/bus.js'
export default {
    name: 'GameList2',
    components: { ReceiveBenefits  },
    data() {
        return {
            id: 0,
            flID: 0,
            curId: 0,
            lang: false,
            delang: true,
            game_like_classf:0,
            screenWidth: document.body.clientWidth,
            games: [],
            gamesfilter:[],
            specialZone: [],
            normalFuFlag: false,//严选新服横栏辅助显示
            gamesClass: [],
            keyWord: '', //关键词
            g_name: '',
            game_name: '', //游戏名称
            img: '', //传递图片给领取福利
            searchGame: [],
            under_time:'',//下架时间
            is_under:'', //是否下架
            countdownIntervals: new Map(), // 存储所有倒计时的interval
        }
    },
    computed: {
        ...mapState([
            'service_id',
            'material',
            'userInfo',
            'serve_quick'
        ]),
    },
    // 监听 localStorage 中的某个属性
    watch: {
        '$ls.serveId': function (newVal, oldVal) {
            // 处理逻辑
        },
        serve_quick:{
            immediate: false, // 立即执行
            deep: false,
            handler (nval, oval) {
                if(nval){
                    this.getGameZone()
                    this.getGameClass()
                    this.getGameList()       
                }
            }
        },
        // 监听游戏数据变化，重新启动倒计时
        gamesfilter: {
            handler() {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.startAllCountdowns();
                    }, 100);
                });
            },
            deep: true
        },
        searchGame: {
            handler() {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.startAllCountdowns();
                    }, 100);
                });
            },
            deep: true
        }
    },
    methods: {
        click_game_class(val){
            this.$czc( '游戏分类', '点击', val)
        },
        //下载游戏链接转换
        downloadFile(url){
            console.log(url)
            location.href = url
        },
        // 跳转到游戏详情
        toGameDetails(id, game_id,uid,classify_name) {
            this.$router.push({
                path: '/gameDetails', query: {
                    id: id,
                    game_id: game_id,
                    uid:uid
                }
            })
            this.$czc( '游戏分类', '点击', classify_name)
        },
        receiveBenefits(game_id) {
            this.$refs.rec.open(game_id)
            if (localStorage.getItem('token')) {
                if(!this.userInfo.user_idcard){
                    this.$message({
                        message: "请先实名认证后使用该功能！",
                        type: 'warning',
                        onClose:()=>{
                            this.$router.push({ path: "/member/realName" })
                            window.location.href=window.location.href
                        },
                        duration: 1500,
                    });
                }else{
                    const receive = $('.receive')
                    var that = this
                    var LayIndex = layer.open({
                        type: 1,
                        content: receive,
                        anim: false,
                        fixed: true,
                        shade: 0.6,
                        move: false,
                        title: this.game_name + '- 福利领取',
                        scrollbar: false,
                        shadeClose: false,
                        isOutAnim: false,
                        closeBtn: 1,
                        Boolean: true,
                        area: ['750px', auto],
                        success: function (layero, index) {
                            layer.style(index, {
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%,-50%)'
                            });
                            window.onresize = () => {
                                return (() => {
                                    layer.style(index, {
                                        transform: 'none'
                                    });
                                })();
                            };
                            $('.layui-layer-page .layui-layer-content').css("overflow", "visible")
                            const lq = $(layero).find('.close');
                            // console.log(lq)
                            lq.click(function () {
                                // 初始化选项
                                that.$refs.rec.fun2()
                                layer.close(LayIndex)
                            })

                        },
                        end:function(){
                            that.$refs.rec.fun2()
                            that.img = ''
                            that.id = ''
                            that.game_name = ''
                            that.is_under = ''
                            this.flID = ''
                        }
                    });
                }
            } else {
                this.$message({
                    message: "请登录后再试！",
                    type: 'warning',
                    duration: 1500
                })
            }

        },
        //获取游戏列表
        getGameList() {
            getGameList().then((res) => {
                if (res.code === 200) {
                    this.games = res.data
                    this.gamesfilter = res.data.filter(item => item.is_show == 1)
                    // this.games.sort((p1,p2)=>{
                    //     return p1.game_id-p2.game_id
                    // })
                    localStorage.setItem('gameList',JSON.stringify(this.games))
                    localStorage.setItem('gameListTime',[res.ex_time])
                } else {
                    console.log(res.msg)
                }
            }).catch((err) => {
                console.log(err)
            })

        },
        
        filteredGamesZone(sz,t) {
            // 返回过滤后的结果
            if(t==1){
                const gamesZonefilter = this.gamesfilter.filter(game => game.zone === sz)
                if(gamesZonefilter && gamesZonefilter.length>0){
                    this.normalFuFlag = true
                }
                return gamesZonefilter
            }else if(t==2){
                // 提取要剔除的 zones
                const excludedZones = this.specialZone?this.specialZone.map(zone => zone.value):[];
                // 过滤掉这些 "zone" 的游戏
                var gameList = this.gamesfilter.filter(game => !excludedZones.includes(game.zone));
                // console.log(this.game_like_classf)
                if(this.game_like_classf) {
                    gameList = gameList.sort((a, b) => {
                        // 匹配度高的排在前面
                        const aMatch = a.classify === this.game_like_classf
                        const bMatch = b.classify === this.game_like_classf
                        
                        if(aMatch && !bMatch) return -1
                        if(!aMatch && bMatch) return 1
                        return 0
                    })
                }
                return gameList
            }
        },
        //获取游戏分区
        getGameZone() {
            getGameZone().then((res) => {
                if (res.code === 200) {
                    localStorage.setItem('gameBoxZone', JSON.stringify(res.data))
                    this.specialZone = JSON.parse(localStorage.getItem('gameBoxZone')) || []
                } else {
                    console.log(res.msg)
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        //获取游戏分类
        getGameClass() {
            getGameClass().then((res) => {
                if (res.code === 200) {
                    localStorage.setItem('gameBoxClass', JSON.stringify(res.data))
                    this.gamesClass = JSON.parse(localStorage.getItem('gameBoxClass'))
                } else {
                    console.log(res.msg)
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        search() {
            if (this.keyWord == '') {
                this.curId = 0
            } else {
                this.sousuo()
                // this.keyWord = ''
            }
        },
        // 搜索接口
        sousuo() {
            searchGameList({ classify: this.games.classify, name: this.keyWord }).then((res) => {
                if (res.code === 200) {
                    this.searchGame = res.data
                    this.searchGame.sort(function (a, b) {
                        return a.id - b.id
                    })
                    if (this.searchGame.length > 0) {
                        this.curId = -1
                    } else {
                        this.curId = 0
                    }
                } else {
                    console.log(res.msg)
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        sendPost() {
            this.getGameZone()
            this.getGameClass()
            this.getGameList()
            console.log('我是全局总线，我被触发了')
        },
        // 新增：将字符串时间转换为Unix时间戳
        parseTimeToTimestamp(timeStr) {
            if (!timeStr) return null;
            
            // 如果是数字，直接返回（可能是已经转换过的时间戳）
            if (typeof timeStr === 'number') {
                return timeStr;
            }
            
            // 如果是 "YYYY-MM-DD HH:mm:ss" 格式的字符串
            if (typeof timeStr === 'string' && timeStr.includes('-')) {
                return Math.floor(new Date(timeStr.replace(/-/g, '/')).getTime() / 1000);
            }
            
            return null;
        },
        // 新增倒计时格式化方法
        // 修改倒计时格式化方法，兼容多种时间格式
        formatCountdown(timeValue) {
            if (!timeValue) return '';
            
            // 转换为Unix时间戳
            const underTime = this.parseTimeToTimestamp(timeValue);
            if (!underTime) return '';
            
            const now = Math.floor(Date.now() / 1000);
            const remaining = underTime - now;
            
            if (remaining <= 0) {
                return '已开始'; // 如果是开服时间，可以显示"已开始"或"已开服"
            }
            
            const days = Math.floor(remaining / (24 * 60 * 60));
            const hours = Math.floor((remaining % (24 * 60 * 60)) / (60 * 60));
            const minutes = Math.floor((remaining % (60 * 60)) / 60);
            const seconds = remaining % 60;
            
            if (days > 0) {
                return `${days} 天 ${hours} 时 ${minutes} 分 ${seconds} 秒`;
            } else if (hours > 0) {
                return `${hours}时${minutes}分${seconds}秒`;
            } else {
                return `${minutes}分${seconds}秒`;
            }
        },

        // 修改：启动所有游戏的倒计时
        startAllCountdowns() {
            this.stopAllCountdowns();
            
            // 为所有有时间字段的游戏启动倒计时
            const allGames = [
                ...this.gamesfilter,
                ...this.searchGame
            ].filter(game => game.under_time || game.kaifu_time);
            
            allGames.forEach(game => {
                this.startCountdown(game.id);
            });
        },
        // 修改：为单个游戏启动倒计时
        startCountdown(gameId) {
            // 如果已经有倒计时在运行，先清除
            if (this.countdownIntervals.has(gameId)) {
                clearInterval(this.countdownIntervals.get(gameId));
            }
            
            const interval = setInterval(() => {
                // 触发组件重新渲染，更新倒计时显示
                this.$forceUpdate();
            }, 1000);
            
            this.countdownIntervals.set(gameId, interval);
        },
        // 新增：停止所有倒计时
        stopAllCountdowns() {
            this.countdownIntervals.forEach((interval, gameId) => {
                clearInterval(interval);
            });
            this.countdownIntervals.clear();
        }

    },
     created() {
        this.$bus.$on('allover',this.sendPost)
        this.time = parseInt(new Date().getTime() / 1000) + ''
        var gameClassTime = localStorage.getItem('gameListTime')
        var isSend = localStorage.getItem('serve_quick')
        var gameChennal =  JSON.parse(localStorage.getItem('game_channel'))
        if(gameChennal){
            this.game_like_classf = gameChennal
        }
        if ((this.time > gameClassTime || !gameClassTime) && isSend) {
            this.getGameZone()
            this.getGameClass()
            this.getGameList()
        } else {
            this.games = JSON.parse(localStorage.getItem('gameList'))
            if(this.games){
                this.gamesfilter = this.games.filter(item => item.is_show == 1)
            }
            this.gamesClass = JSON.parse(localStorage.getItem('gameBoxClass'))
            this.specialZone = JSON.parse(localStorage.getItem('gameBoxZone')) || []
        }
    },
    mounted() {
        this.$nextTick(function () {
            // 立即监听一次
            setTimeout(() => {
                this.screenWidth = document.body.clientWidth
                if (this.screenWidth <= 1700) {
                    this.lang = true
                    this.delang = false
                } else {
                    this.lang = false
                    this.delang = true
                }
            })
            //  仅在整个视图都被重新渲染之后才会运行的代码
            window.addEventListener('resize', () => {
                // 监听窗口大小改变自适应样式
                setTimeout(() => {
                    this.screenWidth = document.body.clientWidth
                    if (this.screenWidth <= 1700) {
                        this.lang = true
                        this.delang = false
                    } else {
                        this.lang = false
                        this.delang = true
                    }
                })
            })
        })
        // 启动倒计时
        this.$nextTick(() => {
            setTimeout(() => {
                this.startAllCountdowns();
            }, 100);
        });
    },
    beforeDestroy() {
        // 组件销毁前清除所有倒计时
        this.stopAllCountdowns();
    },
   
}
</script>
  
<style scoped>
.qutop{
    width: 100%;
    height: 49px;
    background: #B23316;
    margin: 0 0 20px 0;
}
.qutopA{
    width: 100%;
    height: 30px;
    background: url('/public/gamelist/img/2.png') 100% no-repeat;
    background-size: 100% 100%;
    margin: 20px 0 20px 0;
    text-align: center;
}
.text-wrapper_1 {
  height: 125%;
  background: url('/public/gamelist/img/1.png') 100% no-repeat;
  background-size: 100% 100%;
  width: 40%;
  position: relative;
  left: -23px;
  top: -11px;
}
.text_1{
    width: 60%;
    height: 21px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 20px;
    color: #FFECDC;
    line-height: 22px;
    position: relative;
    top: 35%;
    left: 16%;
}
.section_1 {
  background-color: rgba(178, 51, 22, 1);
  height: 49px;
  width: 100%;
  display: flex;
}
.text_2 {
  background-image: linear-gradient(
    180deg,
    rgba(255, 248, 45, 1) 0,
    rgba(255, 248, 45, 1) 0,
    rgba(255, 232, 153, 1) 100%,
    rgba(255, 232, 153, 1) 100%
  );
  width: 60%;
  overflow-wrap: break-word;
  color: rgba(181, 163, 148, 1);
  font-size: 20px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: 700;
  text-align: end;
  white-space: nowrap;
  line-height: 22px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-top: 13px;
}
.text_3{
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 22px;
    color: #B23316;
}
.image_1 {
  height: 82px;
  margin: -27px 0 0 0;
}
.box_padding{
    margin: 0 269px;
}
a {
    text-decoration: none;
    cursor: pointer;
}
.content{
    width: 100%;
}
.game_logo{
    text-shadow: 0 2px 3px rgb(0 0 0 / 55%);
    font-weight: 700;
    color: #333;
    width: 100%;
    text-align: center;
}

.gamelist {
    background: #f5f5f5;
}

.active {
    color: #fff !important;
    background: red;
    border: 1px solid red !important;
}

.game_list {
    padding: 30px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.list_top {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.biaozhi {
    width: 4px;
    height: 22px;
    background: #B5945B;
    margin-right: 10px;

}

.game_top {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.game_top h4 {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin: 0;
}

.list_item {
    display: flex;
    align-items: center;
    justify-content: end;
    margin-top: 15px;
}

.list_item ul {
    list-style: none;
    display: flex;
    margin: 0;
}

.list_item ul li {
    margin-right: 20px;
    cursor: pointer;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #4D4D4D;
    transition: all 0.5s;
    border-radius: 25px;
    border: 1px solid #4D4D4D;
    min-width: 70px;
    height: 31px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
}

.list_item ul li:hover {
    color: #fff;
    background: #4D4D4D;
    transition: all 0.5s;
}

.search_box {
    display: flex;
    align-items: center;
}

.fdj {
    position: absolute;
    margin-left: 8px;
}

.search {
    padding-left: 25px;
    border: 1px solid #808080;
    border-radius: 4px;
    width: 400px;
    height: 38px;
}

.search:focus {
    outline-style: none;
    border-color: #B5945B;
}

/* 模块 */
.box {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    justify-content: start;
    height: 100%;
    width: 100%;
}

.model {
    width: 331px;
    margin-top: 10px;
    margin-right: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.model1 {
    margin-right: 10px;
    margin-top: 10px;
    width: 331px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
}
.model_w{
    /* height: 100%; */
    display: flex;
}
.model_img {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    max-height: 184px;
}
.model_under{
    position: absolute;
    right: 0;
    top: 0;
    width: 25%;
    z-index: 20;
}
.model_img_box {
    position: relative;
    height: 100%;
}
.game_hover_box{
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background: rgb(185, 21, 57, 70%);
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: all .3s linear;
    opacity: 0;
}
.model:hover .game_hover_box{
    opacity: 1;
    transition: all .3s linear;
}
.model1:hover .game_hover_box{
    opacity: 1;
    transition: all .3s linear;
}
.game_hover_img{
    border-radius: 4px;
    width: 50px;
    height: 50px;
}
.game_btn_box{
    margin-top: 20px;
}
.model:nth-of-type(1) {
    margin-left: 0;
}

.model:nth-last-of-type(1) {
    margin-right: 0;
}

.model_title {
    background: #FFFFFF;
    border-radius: 4px;
    padding: 1.25rem;
}

.text_box {
    display: flex;
    flex-direction: column;
}
.game_name{
    cursor: pointer;
}
.fu_title{
    font-size: 12px;
    color: #6c757d ;
}
.g_name{
    max-width: 250px;
}
.text_box h5 {
    margin: 0;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333;
}

.text_logo {
    padding: 2px 10px;
    border: 1px solid #999999;
    border-radius: 4px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
}

.btn_box {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: end;
    align-items: center;
    height: 26px;
}

.down {
    border-radius: 4px;
    padding: 5px 10px;
    background: #CA4242;
    margin-right: 10px;
}

.btn_box a {
    transition: all 0.5s;
}

.btn_box a:hover {
    filter: brightness(1.2);
    transition: all 0.5s;
}

.look {
    border-radius: 4px;
    padding: 5px 10px;
    background: #B5945B;
    margin-right: 10px;
}

.linqv {
    border-radius: 4px;
    padding: 5px 10px;
    background: #dc3545;
}
.web_btn{
    border-radius: 4px;
    padding: 5px 10px;
    background: #ac8747;
}

.lang_btn {
    -webkit-box-orient: vertical;
    white-space: nowrap;
    line-clamp: 1;
    -webkit-line-clamp: 1;
    overflow: hidden;
}

.btn_font {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFEFE;
    text-decoration: none;
}
@media (max-width:1700px) {
    /* .model{
        width: 19.3%;
    }
    .model1{
        width: 251px;
    } */
    .model_img{
        /* max-height: 150px; */
    }
    .box_padding{
        margin: 0 298px;
    }
}

@media (max-width:1600px) {
    .game_top h4 {
        font-size: 20px;
    }

    .list_item ul li {
        font-size: 14px;
    }
   
    /* .model {
        margin-right: 7px;
    }

    .model1 {
        margin-right: 7px;
        width: 252px
    } */
}

@media (max-width:1400px) {
    /* .g_name{
        max-width: 100px;
    } */
    /* .model {
        margin-right: 5px;
        width: 19.5%;
    }
    .model1{
        width: 216px;
    } */
    .list_item ul li {
        margin-right: 15px;
    }

}

@media (max-width:1300px) {

    /* .model {
        margin-right: 5px;
    }

    .model1 {
        margin-right: 5px;
        width: 217px
    } */
    .box_padding{
        margin: 0 200px;
    }
    .text_logo {
        padding: 2px 5px;
    }

    .text_box h5 {
        font-size: 16px;
    }

    .btn_font {
        font-size: 12px;
    }

    .down {
        padding: 5px 10px;
    }

    .look {
        padding: 5px 10px;
    }

    .linqv {
        padding: 5px 10px;
    }
}

@media (max-width:1200px) {
    .list_item ul li {
        font-size: 12px;
    }
    .v_pd {
        padding: 5px 12px;
    }

    .game_top h4 {
        font-size: 14px;
    }
    .box_padding{
        margin: 0 150px;
    }
    /* .model {
        margin-right: 5px;
        width: 19.45%;
    }

    .model1 {
        margin-right: 5px;
        width: 182px
    } */

    .lang_btn {
        display: -webkit-box;
        text-overflow: ellipsis;
        word-break: break-all;
    }
}
@media (max-width:1100px) {
    .box_padding{
        margin: 0 100px;
    }
}
/* 新增倒计时样式 */
.countdown-timer {
    position: absolute;
    top: 130px;
    background: #ff9f43;
    color: white;
    padding: 2px 4px;
    font-size: 12px;
    z-index: 9;
    display: flex;
    align-items: center;
    gap: 4px;
}

.countdown-text {
    font-weight: bold;
}

.countdown-time {
    font-family: 'Courier New', monospace;
    /* background: rgba(0, 0, 0, 0.3); */
    min-width: 80px;
    text-align: center;
}

/* 响应式调整 */
@media (max-width: 1400px) {
    .countdown-timer {
        font-size: 11px;
        padding: 3px 6px;
    }
    
    .countdown-time {
        min-width: 70px;
    }
}

@media (max-width: 1200px) {
    .countdown-timer {
        font-size: 10px;
        padding: 2px 4px;
    }
    
    .countdown-time {
        min-width: 60px;
    }
}
</style>